import { domainsConstants } from '../constants/domains';

const initialState = {
  offer: null,
  domains: [],
  selected: {},
  settings: {},
  count: 0,
  replicaOffersIds: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case domainsConstants.RESET_DOMAIN:
      return {
        ...state,
        selected: {},
        offer: null,
      };
    case domainsConstants.ADD_DOMAIN_SUCCESS:
      return {
        ...state,
      };
    case domainsConstants.SET_DOMAIN_OFFER_SUCCESS:
      return {
        ...state,
        offer: action.offer,
      };
    case domainsConstants.SET_DOMAIN_SUCCESS:
      return {
        ...state,
        selected: action.domain,
      };
    case domainsConstants.SET_DOMAINS_LIST_SUCCESS:
      return {
        ...state,
        domains: action.domains,
        // domains: [],
        count: action.count,
        // count: 0,
      };
    case domainsConstants.REMOVE_DOMAIN_SUCCESS:
      return {
        ...state,
        domains: state.domains.filter(({ id }) => id !== action.id),
      };
    case domainsConstants.SET_DOMAIN_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.settings,
      };
    case domainsConstants.SET_DOMAIN_REPLICA_OFFERS_IDS:
      return {
        ...state,
        replicaOffersIds: action.payload,
      }
    default:
      return state;
  }
};
